import { render, staticRenderFns } from "./validation-lead-action.vue?vue&type=template&id=040e0fa4"
import script from "./validation-lead-action.vue?vue&type=script&lang=js"
export * from "./validation-lead-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports